import { NgModule } from '@angular/core';
import { CustomTooltipContentDirective } from './custom-tooltip-content.directive';
import { CustomTooltipComponent } from './custom-tooltip.component';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';

@NgModule({
  imports: [
    CustomTooltipComponent,
    CustomTooltipContentDirective,
    CdkOverlayOrigin,
  ],
  exports: [
    CustomTooltipComponent,
    CustomTooltipContentDirective,
    CdkOverlayOrigin,
  ],
})
export class CustomTooltipModule {}
